import PropTypes from 'prop-types'
import React from 'react'

import { hasText } from '../../../utils/helpers'
import ZentakeFormContext from '../ZentakeFormContext'
import { MatrixRadioRender } from './MatrixRadioRender'

function MatrixRadioQuestion({
  question,
  isOfficeUse,
  response,
  sessions,
  mode,
}) {
  const formContext = React.useContext(ZentakeFormContext)
  const readonly = formContext.isQuestionReadonly(question)
  const willShowNotAllowedCursor =
    formContext.willShowNotAllowedCursor(question)

  const isDirty = formContext.isQuestionDirty(question)
  const isValid = formContext.isQuestionValid(question)
  const questionError = formContext.getQuestionError(question)

  const [hasError, setHasError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(
    'This field is required'
  )

  const officeUsePreview = mode === 'preview' && question.is_office_use_only

  React.useEffect(() => {
    setHasError(
      (isDirty && question?.is_required && !isValid) || hasText?.(questionError)
    )
    setErrorMessage?.(
      questionError && typeof questionError === 'string'
        ? questionError
        : 'This field is required'
    )
  }, [isDirty, question.is_required, isValid, questionError])

  function getCellValue(rowId, columnId) {
    const answer = formContext?.getAnswerCell?.(rowId, columnId)
    return !!answer
  }

  function handleCellChange(rowData, columnData) {
    formContext?.onAnswerCellChanged?.(question, rowData, columnData)
  }

  return (
    <MatrixRadioRender
      errorMessage={errorMessage}
      getCellValue={getCellValue}
      handleCellChange={handleCellChange}
      hasError={hasError}
      help_text={question.help_text}
      isDirty={isDirty}
      isOfficeUse={isOfficeUse || officeUsePreview}
      isRequired={question.is_required}
      isValid={isValid}
      label={question.text}
      questionError={questionError}
      questionId={question.id}
      question_columns={question.question_columns}
      question_rows={question.question_rows}
      readonly={readonly}
      response={response}
      sessions={sessions}
      willShowNotAllowedCursor={willShowNotAllowedCursor}
    />
  )
}

MatrixRadioQuestion.propTypes = {
  question: PropTypes.object.isRequired,
}

export default React.memo(MatrixRadioQuestion)
